import QueryString from "qs";
import { useRouter } from "next/router";
import { useEffect } from "react";
import { GetServerSideProps, NextPage } from "next";
import Banner from "@/Components/pages/ThankYou/banner";
import HocHead from "@/Components/HigherOrderComponent/HocHead";
import ThankYouBlogs from "@/Components/pages/ThankYou/ThankYouBlogs";

const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_API_BASE_URL;

interface Props {
  pageData: any;
}
const ThankYou: NextPage<Props> = ({ pageData }) => {
  const blocks = pageData?.blocks;
  const seo = pageData?.seo;
  const router = useRouter();

  useEffect(() => {
    const formData: any = sessionStorage.getItem("form-data");
    // Reload GTM on route change
    window.dataLayer = window.dataLayer || [];
    const eventData = {
      event: "eec.purchase",
      pagePath: router.asPath,
      data: JSON.parse(formData),
    };

    window.dataLayer.push(eventData);

    sessionStorage.removeItem("form-data");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <HocHead seo={seo || {}} type="template" />
      <Banner />
      {blocks?.map(
        (block: any, i: any) =>
          block.__component === "blocks.2025-thank-you-blog" && (
            <div key={i}>
              <ThankYouBlogs block={block} />
            </div>
          ),
      )}
    </>
  );
};

interface HomePageProps {
  pageData: any;
}

export const getServerSideProps: GetServerSideProps<HomePageProps> = async () => {
  let pageData = {};
  const query = QueryString.stringify(
    {
      filters: {
        slug: {
          $eq: "thank-you",
        },
      },
      populate: "deep",
    },
    {
      encodeValuesOnly: false,
    },
  );
  const response = await fetch(
    `${baseUrl}thank-you?${decodeURIComponent(query)}`,
  );
  const resData = await response.json();
  if (resData) {
    pageData = resData?.data?.attributes;
  }

  return {
    props: {
      pageData,
    },
  };
};

export default ThankYou;
